import capitaliseFirstLetter from '../helpers/capitaliseFirstLetter'
import genCombatantName from '../helpers/genCombatantName'
import copyObjectNoRef from '../helpers/copyObjectNoRef'
import combatantNames from '../helpers/combatantNames'
import useEditCombatant from './useEditCombatant'
import isName from '../helpers/isName'

import store from '../store/index'
//-------------------------
// add multiple combatants
//-------------------------
export default async function useAddMultipleCombatants(args) {
  // console.log("----------------------------------")
  // console.log("IN useAddMultipleCombatants...")
  let j = 0
  let responses = []
  //-----------
  // get store
  //-----------
  const this_store = store.state.combat
  //--------------------------
  // loop based upon quantity
  //--------------------------
  for (let i = 0; i < args.qty; i++) {
    //-----------------------
    // copy combatant object (prevent vals overwritten where qty > 1)
    //-----------------------
    let copy_combatant = copyObjectNoRef(args.new_combatant)
    //--------------------------------------------
    // recopy image file to maintain formdata fmt
    //--------------------------------------------
    copy_combatant.image_file = args.new_combatant.image_file
    //------------
    // reset vars
    //------------
    j = i + 1
    let combatantCreated = false
    //----------------------------------------
    // loop until combatant name is available
    //----------------------------------------
    while (combatantCreated == false) {
      let new_name = ''
      //------------------------------
      // gen potential combatant name
      //------------------------------
      new_name = capitaliseFirstLetter(
        genCombatantName(copy_combatant.name, copy_combatant.type, j),
      )
      //----------------------
      // check if name exists
      //----------------------
      if (isName(new_name, combatantNames(this_store.arena.arena_combatants))) {
        //---------------------------------
        // name already exists - try again
        //---------------------------------
        j++
        //---------------------
        // name does not exist
        //---------------------
      } else {
        //----------------------
        // change combatant name
        //-----------------------
        copy_combatant.name = new_name
        //------------------------
        // flag combatant created (avoid loop on error)
        //------------------------
        combatantCreated = true
        //---------------
        // add combatant
        //---------------
        let api_call = useEditCombatant(copy_combatant)
        await api_call.then((response_parms) => {
          responses.push(response_parms)
        })
      }
    }
  }
  return responses
}
